import { QUANTITY, toISTDate } from '@Apis/constants';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;

  // const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  return [
    {
      label: 'Products',
      value: record.seller_product_count ? record.seller_product_count : 0,
    },
    {
      label: 'Linked Customers',
      value: record?.seller_info?.customer_name,
    },
    {
      label: 'Created Date',
      value: toISTDate(record?.seller_info?.created_date).format('DD/MM/YYYY'),
    },
    {
      label: 'Bank Account No',
      value: record?.seller_info?.bank_account_no || '-',
    },
    {
      label: 'Bank IFSC No',
      value: record?.seller_info?.bank_ifsc || '-',
    },
  ];
};
export {
  ListScreenKeys,
};